import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  container: {
    // flex: 1,
    marginTop: 20,
    marginBottom: 15,
  },
  listStyle: {
    marginBottom: 10,
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  showAll: {
    alignSelf: 'flex-end',
  },
  seeAllContent: {
    flexDirection: 'row',
  },
});
